import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';
import { CommunicationPhoneTypeReferenceModel } from '../../models/reference-model/reference-general-model';


@Injectable({
    providedIn: 'root'
})
export class CommunicationPhoneTypeReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/CommunicationPhoneTypeReferences"

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getCommunicationPhoneTypeReferences(): Observable<CommunicationPhoneTypeReferenceModel[]> {
        return this.httpGet<CommunicationPhoneTypeReferenceModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}